import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography, Stack } from '@mui/material';
// sections
import { LoginForm } from '../sections/auth/login';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  idth: '100%',
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  //minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  marginTop: ".5rem",//theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage({setToken}) {

  return (
    <>
      <Helmet>
        <title> Login </title>
      </Helmet>

      <StyledRoot>
        <Stack>
        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h4" gutterBottom>
              Accedi
            </Typography>

            <br/>
            <LoginForm setToken={setToken} />
          </StyledContent>
        </Container>
        </Stack>
      </StyledRoot>
    </>
  );
}
